export const modal_action = "modal_action/change";


/**
 *
 * @param code
 * @param data
 * @param callback
 * @returns {{type: string, payload: {display: boolean, code: string, data: {icon, header, message, buttons}, callback: null|Function}}}
 */
export const modalShow = (code, data, callback=null) => ({
    type: modal_action,
    payload: {
        display: true,
        code,
        data,
        callback
    }
});

export const modalHide = () => ({
    type: modal_action,
    payload: {
        display: false,
        code: null,
        data: null,
        callback: null
    }
});


// WEBPACK FOOTER //
// ./src/libs/redux/actions/modal.js